export default __webpack_public_path__ + "static/media/1.23e63a4e.jpg";